import type { RenderContext, RenderField } from "../types.ts";
import { renderTextLikeField } from "./text-input.ts";

export const renderWebsiteField = (
  field: RenderField<"WEBSITE">,
  context: RenderContext,
): HTMLElement => {
  const rules = field.validationJson;

  return renderTextLikeField(field, context, "url", (input) => {
    if (rules?.httpsOnly) {
      input.pattern = "https://.*";
      input.title = "Use an HTTPS URL.";
    }
  });
};
